import LandingPoint from './LandingPoint.vue'
export default LandingPoint